const notrecovery = () =>
  import('@/views/main/receipt/notrecovery/notrecovery.vue')
export default {
  path: '/main/receipt/notrecovery',
  name: 'notrecovery',
  component: notrecovery,
  children: []
}
